const serverDemoGif = "https://i.ibb.co/VY9tQpz/server.gif";
const playerDemoGif = "https://i.ibb.co/56JLm9X/player.gif";
const importDemoGif = "https://i.ibb.co/jLP8Kxy/import.gif";
const playlistDemoGif = "https://i.ibb.co/TbxgTxH/playlist.gif";

const searchingGif = "https://i.ibb.co/rM2Zpq5/loading.gif";
const playingLongGif = "https://i.ibb.co/GMWSH7h/playing-long.gif";
const playingGif = "https://i.ibb.co/C8Sv5yy/playing.gif";

const defaultThumbnail = "https://i.ibb.co/9hXmRF6/logo.png";
const authBackground = "https://i.ibb.co/MPnV0xw/auth-background.png";
const avatar = "https://i.ibb.co/2jGp1W6/avatar.png";
const notFound404 = "https://i.ibb.co/cwWV2ck/404.png";
const appLogogText = "https://i.ibb.co/5ktPz1Z/logo-text.png";
const serverArt = "https://i.ibb.co/T4Ld3PX/server-art.png";

const ankitImg = "https://i.ibb.co/JRnVCxd/ankit1.jpg";

export {
  serverDemoGif,
  playerDemoGif,
  importDemoGif,
  playlistDemoGif,
  searchingGif,
  playingLongGif,
  playingGif,
  defaultThumbnail,
  authBackground,
  avatar,
  notFound404,
  appLogogText,
  serverArt,
  ankitImg,
};
